import { TemplatePoolByTag, } from "../sharedScripts/templates";
function getTokens(line) {
    return line.split(" ");
}
const isOperator = (token) => token === "#@jest-równe";
const isToken = (token) => token === "#@jest-równe" ||
    token === "#@jeżeli" ||
    token === "#@zakończ-warunek";
export function ParseDTScript(text, config) {
    const state = JSON.parse(text);
    const newState = {
        blocks: [],
        entityMap: state.entityMap,
    };
    const pool = TemplatePoolByTag[config.templatePool];
    const activeConditions = [];
    for (const block of state.blocks) {
        const { text: line } = block;
        let firstBlock = Object.assign(Object.assign({}, block), { text: "" });
        const finalBlocks = [firstBlock];
        let tokens = getTokens(line);
        const lineTypeToken = tokens[0];
        function getLast() {
            return finalBlocks[finalBlocks.length - 1];
        }
        for (const token of tokens) {
            const tokenName = token.replace("#", "");
            if (token.startsWith("#")) {
                if (tokenName === "#prawda") {
                    getLast().text += "true ";
                    continue;
                }
                if (tokenName === "#fałsz") {
                    getLast().text += "false ";
                    continue;
                }
            }
            if (token.startsWith("#") && pool[tokenName]) {
                const tokenValue = config.templateContext[pool[tokenName].name];
                tokenValue.split("\n").forEach((line, index) => {
                    if (index !== 0) {
                        const nextBlock = Object.assign(Object.assign({}, block), { text: "", inlineStyleRanges: [], entityRanges: [] });
                        finalBlocks.push(nextBlock);
                    }
                    getLast().text += line + " ";
                });
                continue;
            }
            getLast().text += token + " ";
        }
        tokens = getTokens(getLast().text);
        if (lineTypeToken === "#@jeżeli") {
            const operatorIndex = tokens.findIndex(isOperator);
            const operator = tokens[operatorIndex];
            if (operator) {
                let tokenBeforeFound = false;
                const value1 = tokens
                    .slice(0, operatorIndex)
                    .reduceRight((acc, token) => {
                    if (tokenBeforeFound === false && isToken(token)) {
                        tokenBeforeFound = true;
                    }
                    return (tokenBeforeFound ? "" : token) + acc;
                }, "");
                let tokenAfterFound = false;
                const value2 = tokens.slice(operatorIndex + 1).reduce((acc, token) => {
                    if (tokenAfterFound === false && isToken(token)) {
                        tokenAfterFound = true;
                    }
                    return acc + (tokenAfterFound ? "" : token);
                }, "");
                if (operator === "#@jest-równe") {
                    activeConditions.push(value1 === value2);
                }
            }
        }
        else if (lineTypeToken === "#@zakończ-warunek") {
            activeConditions.pop();
        }
        else {
            if (activeConditions.every((conditionResult) => conditionResult === true)) {
                newState.blocks.push(...finalBlocks.map((block) => (Object.assign(Object.assign({}, block), { text: block.text }))));
            }
        }
    }
    return JSON.stringify(newState);
}
